/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { JwtToken } from '../models/JwtToken';
import type { PostServicePanelTransitionConsumeRequestAdmin } from '../models/PostServicePanelTransitionConsumeRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ServicePanelTransitionConsumerService {
    /**
     * @returns JwtToken OK
     * @throws ApiError
     */
    public static postServicePanelTransitionConsumeAdmin({
        requestBody,
    }: {
        requestBody?: PostServicePanelTransitionConsumeRequestAdmin,
    }): CancelablePromise<JwtToken> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/servicepaneltransitionconsumer/public/consume',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
